<template>
  <div class="im-dialog-info-group">{{ data.title }}</div>
</template>

<script>
  export default {
    name: 'Group',
    props: {
      data: {
        type: Object,
        default: function () {
          return {
            id: null,
            title: null
          };
        }
      }
    }
  };
</script>

<style scoped>

</style>